import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import LoginForm from './components/LoginForm'
import AuthenticatedRoute from './components/AuthenticatedRoute'
import Dashboard from './components/Dashboard'
import { Orders } from './pages/Orders'
import { CreateOrder } from './pages/CreateOrder'
import { ViewOrder } from './pages/ViewOrder'
import { Timesheet } from './pages/Timesheet'
import { TimesheetReports } from './pages/TimesheetReports'
import { ESSCOProducts } from './pages/ESSCOProducts'
import { DropdownExamples } from './components/examples/DropdownExamples'
import { getToken, setToken, getUser, setUser } from './lib/api'
import { ThemeProvider } from './themes'
import type { User } from './types/index'



// Login page wrapper
const LoginPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const token = getToken()
    const savedUser = getUser()
    if (token && savedUser) {
      setIsAuthenticated(true)
    }
  }, [])

  const handleLogin = (token: string, userData: Pick<User, 'id' | 'username' | 'role'>) => {
    setToken(token)
    setUser(userData)
    setIsAuthenticated(true)
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return <LoginForm onLogin={handleLogin} />
}

// Dashboard wrapper to pass user data
const DashboardPage = () => {
  const user = getUser()
  if (!user) return <Navigate to="/login" replace />
  
  return <Dashboard user={user} />
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={
            <AuthenticatedRoute requiredPermission="dashboard">
              <DashboardPage />
            </AuthenticatedRoute>
          } />
          <Route path="/orders" element={
            <AuthenticatedRoute requiredPermission="orders">
              <Orders />
            </AuthenticatedRoute>
          } />
          <Route path="/orders/create" element={
            <AuthenticatedRoute requiredPermission="orders">
              <CreateOrder />
            </AuthenticatedRoute>
          } />
          <Route path="/orders/edit/:orderId" element={
            <AuthenticatedRoute requiredPermission="orders">
              <CreateOrder />
            </AuthenticatedRoute>
          } />
          <Route path="/orders/view/:orderId" element={
            <AuthenticatedRoute requiredPermission="orders">
              <ViewOrder />
            </AuthenticatedRoute>
          } />
          <Route path="/timesheet" element={
            <AuthenticatedRoute requiredPermission="timesheets">
              <Timesheet />
            </AuthenticatedRoute>
          } />
                  <Route path="/timesheet-reports" element={
          <AuthenticatedRoute requiredPermission="reports">
            <TimesheetReports />
          </AuthenticatedRoute>
        } />
        <Route path="/essco-products" element={
          <AuthenticatedRoute requiredPermission="orders">
            <ESSCOProducts />
          </AuthenticatedRoute>
        } />
          <Route path="/components" element={
            <AuthenticatedRoute requiredPermission="settings">
              <DropdownExamples />
            </AuthenticatedRoute>
          } />
          <Route path="/" element={<Navigate to="/timesheet" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  )
}

export default App
